export default {
  // Page
  title: 'Roster',
  description: 'Jobs and the crew on each. Drag employees onto a job, drag a job to another day to move it, and hold Alt while dropping to duplicate it.',
  publishDraftsOne: 'Publish {count} draft',
  publishDraftsOther: 'Publish {count} drafts',
  copyWeek: 'Copy week',
  newShift: 'New shift',
  newJob: 'New job',
  previousWeek: 'Previous week',
  thisWeek: 'This week',
  nextWeek: 'Next week',
  claimsToReviewOne: '{count} open-spot claim to review',
  claimsToReviewOther: '{count} open-spot claims to review',
  filterBySite: 'Filter by site',
  allSites: 'All sites',
  employees: 'Employees',
  searchEmployees: 'Search employees',
  dragToAssign: 'Drag onto a job to assign',
  noEmployeesMatch: 'No employees match.',
  addJobOn: 'Add a job on {day}',
  leaveAndAvailability: 'Leave & availability',
  leaveAndAvailabilityHint: "Approved leave, leave awaiting approval (dashed), and times people said they can't work.",
  noJobs: 'No jobs this week.',
  noJobsCanEdit: 'No jobs this week. Create one to start rostering.',
  shifts: 'Shifts',
  shiftsHint: 'Open a shift to edit it, or to cancel a repeating one from that day on.',
  noShifts: 'No shifts this week.',
  noShiftsCanEdit: 'No shifts this week. Use New shift to add one, or a repeating pattern.',

  // Day, week and month views
  viewLabel: 'Roster view',
  viewDay: 'Day',
  viewWeek: 'Week',
  viewMonth: 'Month',
  previousDay: 'Previous day',
  today: 'Today',
  nextDay: 'Next day',
  previousMonth: 'Previous month',
  thisMonth: 'This month',
  nextMonth: 'Next month',
  noJobsDay: 'No jobs on this day.',
  noJobsDayCanEdit: 'No jobs on this day. Create one to start rostering.',
  noShiftsDay: 'No shifts on this day.',
  noShiftsDayCanEdit: 'No shifts on this day. Use New shift to add one, or a repeating pattern.',
  openDay: 'Open {day}',
  monthMore: '+{count} more',
  monthOnLeave: '{count} on leave',

  // Availability and clashes
  onLeave: 'On leave',
  unavailable: 'Unavailable',
  leaveApprovedTitle: '{category} (approved)',
  leavePendingTitle: '{category} (awaiting approval)',
  pending: 'Pending',
  unavailableWindow: 'Unavailable {window}',
  unavailableWindowNote: 'Unavailable {window} ({note})',
  offWindow: 'Off {from}–{to}',

  // Job block
  statusAccepted: 'Accepted',
  statusPending: 'Awaiting reply',
  statusDeclined: 'Declined',
  draft: 'Draft',
  published: 'Published',
  mandatory: 'Mandatory',
  repeats: 'Repeats',
  duplicateJob: 'Duplicate job',
  editJob: 'Edit job',
  dragJobHint: 'Drag to another day to move. Hold Alt to duplicate.',
  removeEmployee: 'Remove {name}',
  dragAssignmentHint: 'Drag onto another job to assign them there too',
  assigned: 'Assigned',
  declineReason: '“{reason}”',
  dropEmployeesHere: 'Drop employees here',
  noOneAssigned: 'No one assigned',
  crewSummary: '{accepted} accepted · {pending} awaiting reply · {declined} declined',
  showAllCrew: 'Show all {count}',
  showFewerCrew: 'Show fewer',
  publish: 'Publish',
  editShiftAria: "Edit {name}'s shift at {site}",

  // Duplicate job
  skippedCrew: "Duplicated, but some crew couldn't be added: {details}.",
  cloneDescription: 'Copies “{title}” with the same site, times, notes, checklist and settings as a new draft.',
  jobDuplicated: 'Job duplicated as a draft',
  startOn: 'Start on',
  copyCrew: 'Copy the crew ({count})',
  duplicate: 'Duplicate',

  // Copy week
  jobOne: '{count} job',
  jobOther: '{count} jobs',
  shiftOne: '{count} shift',
  shiftOther: '{count} shifts',
  copySummary: '{jobs} and {shifts}',
  copyWeekTitle: 'Copy a week',
  copyWeekDescription: "Copies jobs (as drafts, with their crew and checklist) and shifts into the week of {date}. Cancelled ones aren't copied.",
  copyWeekDescriptionSite: "Copies jobs (as drafts, with their crew and checklist) and shifts into the week of {date} for this site. Cancelled ones aren't copied.",
  copiedDone: 'Copied {summary}.',
  copiedSkipped: 'Copied {summary}. {count} skipped.',
  copyFrom: 'Copy from the week of',
  copyFromHint: 'Any day in that week.',
  nothingToCopy: 'Nothing to copy from that week.',
  willBeCopied: '{summary} will be copied.',
  skippedCount: '{count} skipped:',
  crewLeftOff: '{job}: left off {detail}',
  copyButton: 'Copy {summary}',
  preview: 'Preview',

  // Repeat day
  repeatDay: 'Repeat day',
  repeatDayOn: 'Repeat the jobs on {day}',
  repeatDayTitle: 'Repeat a day',
  repeatDayDescription: "Copies the jobs that start on {date} (as drafts, with their crew and checklist) onto the days you pick. Cancelled jobs aren't copied.",
  repeatDayDescriptionSite: "Copies this site's jobs that start on {date} (as drafts, with their crew and checklist) onto the days you pick. Cancelled jobs aren't copied.",
  repeatOn: 'Repeat on',
  repeatOnHint: 'Add each day the jobs should be copied to.',
  addDay: 'Add day',
  removeDay: 'Remove {date}',
  nothingToRepeat: 'No jobs start on that day, so there is nothing to repeat.',
  repeatNothingCreated: 'Nothing would be created.',
  repeatWillCreate: '{jobs} will be created as drafts.',
  repeatTargetLine: '{date}: {jobs}',
  repeatCreate: 'Create {jobs}',
  repeatDone: "Created {jobs} as drafts. Publish them when you're ready.",
  repeatDoneSkipped: 'Created {jobs} as drafts. {count} skipped.',

  // Attendance exceptions
  notOnSite: 'Not on site',
  startedAt: 'started {time}',
  escalated: 'Escalated {when}',
  reminded: 'Reminded {when}',

  // Publishing
  publishFailedOne: '{count} job could not be published',
  publishFailedOther: '{count} jobs could not be published',
  publishedJobs: 'Published {jobs}',
  publishedJobsWithSpots: 'Published {jobs}. {spots} posted to the app',
  openSpotOne: '{count} open spot',
  openSpotOther: '{count} open spots',
  publishedMoreOne: 'Published {count} more job',
  publishedMoreOther: 'Published {count} more jobs',

  // Hours & cost card
  personOne: '{count} person',
  personOther: '{count} people',
  rostered: '{hours} rostered',
  overThreshold: '{count} over {hours}',
  exclNotCosted: 'excl. {count} not costed',
  costNoRate: 'No pay rate',
  costSalaried: 'Salaried',
  scopeSite: 'At this site',
  scopeManagedSites: 'At your sites',
  noteMissingRate: 'Cost leaves out {people} with no pay rate ({hours} rostered). Add rates on their Pay tab.',
  noteSalaried: "Salaried staff ({count}) aren't costed per hour.",
  noteUnreadableOne: "{count} pay rate couldn't be read on the server.",
  noteUnreadableOther: "{count} pay rates couldn't be read on the server.",
  noteNoOvertimeLoading: 'Overtime is costed at the base rate: pay rates have no overtime loading.',
  noteCounting: "Counts scheduled shifts and job crew who've accepted or not replied yet. A job longer than a day counts its daily hours on each day, and overlapping time counts once.",
  noteCountingDrafts: "Counts scheduled shifts and job crew who've accepted or not replied yet, drafts included. A job longer than a day counts its daily hours on each day, and overlapping time counts once.",
  wholeWeekCost: '{amount} for their whole week',
  hoursAndCost: 'Hours & cost',
  hours: 'Hours',
  noRosteredHours: 'No rostered hours this week.',
  colPerson: 'Person',
  colWeek: 'Week',
  colOver: 'Over {hours}',
  colCostHere: 'Cost here',
  colCost: 'Cost',
  weekTotal: 'Week total',
  nobodyRostered: 'Nobody is rostered this week.',
  nobodyRosteredScoped: 'Nobody is rostered this week at these sites.',

  // Overtime settings card
  overtimeSaved: 'Overtime limit saved.',
  weeklyHoursLabel: 'Weekly hours before overtime',
  weeklyHoursHint: 'Per person, Monday to Sunday. 38 is the full-time standard.',
  saveLimit: 'Save limit',
  overtimeTitle: 'Overtime on the roster',
  overtimeDescription: "The Roster flags anyone rostered for more than this many hours in a week. It's a planning warning only: it doesn't change pay rates or apply award rules.",

  // lib/roster
  statusCancelled: 'Cancelled',
  statusScheduled: 'Scheduled',
  skipOverlap: 'already has a shift then',
  skipCrewBooked: 'already booked then',
  skipDuplicate: 'already on that week',
  skipInactiveEmployee: 'no longer active',
  skipInactiveSite: 'site is inactive',
  skipLeave: 'on leave',
  skipUnavailable: 'unavailable',
  skipWithWho: '{who}, {date}: {reason}{detail}',
  skipNoWho: '{date}: {reason}{detail}',
  skipsMore: '{shown}; and {count} more',

  // lib/rosterConflicts
  fromDate: 'from {date}',
  allDay: 'All day',
  leave: 'Leave',
  conflictLeave: '{label}, {range}{note}',
  conflictUnavailable: 'Unavailable {when}, {window}{note}',
  everyDays: 'every {days}',
  everyDaysUntil: 'every {days} until {date}',

  // lib/rosterHours
  hoursShort: '{h}h',
  minutesShort: '{m}m',
  hoursMinutesShort: '{h}h {m}m',
}
